import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 401 bedeutet "Token weg" — Wiederholen bringt nichts, der zentrale
      // Handler (siehe authStore.bindAuthToApiClient) hat die Session bereits
      // beendet. Retries wuerden nur zusaetzliches Rauschen erzeugen.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status === 401) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
    mutations: {
      retry: 0,
    },
  },
});
